import React, { useState } from "react";
import Filter from "./icons/Filter";
import get from "lodash/get";
import Close from "./icons/Close";

export default function FilterList({
  items,
  fields,
  children,
}: {
  items: any[];
  fields: string[];
  children: Function;
}) {
  const [text, setText] = useState("");

  if (items.length < 5) {
    return children(items);
  }

  return (
    <>
      <li className={"filter-items " + (text !== "" ? "expanded" : "")}>
        <Filter size={18} className="filter-icon" />
        <input
          value={text}
          type="text"
          placeholder="Filter"
          onChange={(e) => setText(e.target.value)}
        />
        <button className="reset as-link" onClick={() => setText("")}>
          <Close size={18} className="close-icon" />
        </button>
      </li>
      {children(
        text === ""
          ? items
          : items.filter((item) => {
              return fields.some((field) => {
                const value = get(item, field);
                return typeof value !== "undefined"
                  ? value.match(new RegExp(text, "gi"))
                  : false;
              });
            })
      )}
    </>
  );
}
